import revertIcon from "../../../../../../assets/images/revert.svg";
import redo from "../../../../../../assets/images/redo.svg";
import trim_svg from "../../../../../../assets/images/image-trim.svg";
import arrow_dropdown from "../../../../../../assets/images/down-arrow.svg";
import claenderOne from "../../../../../../assets/images/calender1.svg";
import uploadicon from "../../../../../../assets/images/uploadicon.png";
import { useState } from "react";
import { ScheduleUpload_URL } from "../../../../../../service/API_URL";
import { postFormData } from "../../../../../../api/apiMethod";
import { toast } from "react-toastify";
import { CsvErrorPopUp } from "../../../../CsvErrorPopUp";

export const ActionToolbar = ({
    locationState,
    trim_programs_space,
    SaveAndUpdate,
    saveBtnValue,
    setSaveBtnValue,
    loaderStatus,
    setWeeklyView,
    undoGridList,
    redoGridList,
    canUndo,
    canRedo,
    today
}) => {
    const [showPopup, setShowPopup] = useState(false);
    const [csvErrorData, setCsvErrorData] = useState([]);

    const listUpdate = (channelAssembly) => {
        if (channelAssembly === "RUNN_MEDIA") {
            document.getElementById("fileid").click();
        }
    }
    const uploadFile = async (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            const formData = new FormData();
            formData.append("file", selectedFile);
            try {
                let URL = "";
                if (locationState?.state?.channelAssembly === "RUNN_MEDIA") {
                    URL = `${ScheduleUpload_URL}/${locationState?.state?.channelId}/schedule/internal/csv`;
                } else {
                    URL = `${ScheduleUpload_URL}/${locationState?.state?.channelId}/schedule/external/csv`;
                }
                const response = await postFormData(URL, formData);
                
                if (response?.data?.status) {
                    toast.success("File uploaded successfully", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        autoClose: 5000,
                    });
                    today();
                } else {
                    if (response?.data?.data != null) {
                        setShowPopup(true);
                        setCsvErrorData({...response?.data, fileName: selectedFile?.name});
                    }
                    toast.error(response?.data?.message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        autoClose: 10000,
                    });
                }
            } catch (error) {
                toast.error(error.response.data.message, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    autoClose: 10000,
                });
            }
        }
        event.target.value = ""; 
    }
    const closePopup = () => {
        setShowPopup(false);
    };
    return (
        <div className="right-side d-flex" style={{ margin: "8px 0px 16px 0px" }}>
            <a className='btn btn-revert mx-1 p-1' style={{width: '2rem', height:'2rem', background: "#444649"}} onClick={undoGridList} disabled={!canUndo}><img src={revertIcon} width={24}/></a>
            <a className='btn btn-revert mx-1 p-1' style={{width: '2rem', height:'2rem', background: "#444649"}} onClick={redoGridList} disabled={!canRedo}><img src={redo} width={24}/></a>
            <a className='btn btn-revert mx-1 p-1' style={{width: '2rem', height:'2rem', background: "#444649"}}><img src={uploadicon} style={{filter: "invert(0.90)"}} width={24} onClick={() => listUpdate(locationState?.state?.channelAssembly)}/></a>
            <a className='btn btn-revert mx-1 p-1' style={{width: '2rem', height:'2rem', background: "#444649"}}><img src={claenderOne} width={24} onClick={() => setWeeklyView(true)}/></a>
            <a className='btn btn-revert mx-1 p-1' style={{width: '2rem', height:'2rem', background: "#444649"}} onClick={()=>trim_programs_space()}><img src={trim_svg} width={24}/></a>
            {
                locationState?.state?.permission === "edit" &&
                <>
                    <div className="btn-group mx-1">
                        <button 
                            type="button" 
                            className="btn btn-primary p-2 radius-8x" 
                            onClick={() => SaveAndUpdate(saveBtnValue)}
                            disabled={loaderStatus} 
                            style={{height: "2rem", fontSize: "0.875rem", fontWeight: "400"}}
                        >
                            {
                                loaderStatus &&
                                <div className="loader me-1" style={{width: "20px", height: "20px", marginBottom: "0px"}}>
                                </div>
                            }
                            Save & Publish
                        </button>
                        {/* <button type="button" className="btn btn-primary p-2" onClick={() => SaveAndUpdate(saveBtnValue)}>{saveBtnValue}</button>
                        <button type="button" className="btn btn-primary dropdown-toggle dropdown-toggle-split pe-1" data-bs-toggle="dropdown" aria-expanded="false">
                            <img src={arrow_dropdown} style={{ filter: "invert(1)" }} />
                        </button>
                        <ul className="dropdown-menu" style={{transform: "translate(78.5px, 46.25px)"}}>
                            {
                                saveBtnValue === "Save & Publish"?
                                <li onClick={() => setSaveBtnValue("Save")}><a className="dropdown-item" >Save</a></li>
                                :
                                <li onClick={() => setSaveBtnValue("Save & Publish")}><a className="dropdown-item" >Save & Publish</a></li>
                            }
                        </ul> */}
                    </div>
                </>
            }
            <button className='btn btn-danger mx-1 radius-8x' style={{height: "2rem", fontSize: "0.875rem"}}>Auto Schedule</button>
            <input
                id="fileid"
                type="file"
                hidden
                onChange={(event) => uploadFile(event)}
            />
            {
                showPopup &&
                <CsvErrorPopUp show={showPopup} csvErrorData={csvErrorData} handleClose={closePopup}/>
            }
        </div>
    )
}